<template>
  <Block tagName="div" type="onestoreSubscribeDetailItem">
    <div class="onestore-subscribe-content-wrap">
      <div class="sub-ico-wrap">
        <img :src="icon" />
      </div>
      <div class="sub-content-wrap">
        <Mark type="subscribeItemProduct">{{ productName }}</Mark>
        <Mark type="subscribeItemDesc">{{ productDesc }}</Mark>
      </div>
    </div>
  </Block>
</template>
<script>
export default {
  props: ['productName', 'productDesc', 'icon'],
};
</script>
